import { render, staticRenderFns } from "./EditStudents.vue?vue&type=template&id=9b6481ce&"
import script from "./EditStudents.vue?vue&type=script&lang=js&"
export * from "./EditStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports